module.exports = __webpack_public_path__ + "img/preloader.0831ddf4.gif";